import { logger } from 'lib/logger';
import { getSocialBinds } from 'reactApp/api/axios.corsapi';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendXray } from 'reactApp/utils/ga';
import { call, cancel, put, race, select, take, takeEvery } from 'redux-saga/effects';

import { getUserSocialBindsFailure, getUserSocialBindsRequest, getUserSocialBindsSuccess } from './userSocialBinds.module';
import { UserSocialBindSelectors } from './userSocialBinds.selectors';

export function* handleUserSocialBindSuccess() {
    const { isLoaded, isLoading } = yield select(UserSocialBindSelectors.getLoadingState);

    if (isLoaded && !isLoading) {
        return true;
    }

    const { success } = yield race({
        success: take(getUserSocialBindsSuccess),
        fail: take(getUserSocialBindsFailure),
    });

    return !!success;
}

function* handleUserSocialBindRequest() {
    const email = yield select(UserSelectors.getEmail);
    try {
        const data = yield call(getSocialBinds, email);
        if (!data) {
            yield put(getUserSocialBindsFailure());
            yield cancel();
        }
        yield put(getUserSocialBindsSuccess({ socialBinds: data }));
    } catch (error) {
        logger.error(error);
        sendXray('bind_list_error');

        yield put(getUserSocialBindsFailure());
        yield cancel();
    }
}

export function* watchUserSocialBindRoot() {
    yield takeEvery(getUserSocialBindsRequest.toString(), handleUserSocialBindRequest);
}
